module.exports = __webpack_public_path__ + "static/media/lupa.bbaa611c.svg";